<template>
  <QTabs
    align="justify"
    active-color="secondary"
    class="bg-white q-my-md rounded-borders text-grey-8 q-tabs--inset-indicator q-tabs--no-focus-helper"
  >
    <QRouteTab
      class="q-py-sm"
      :ripple="false"
      label="Car"
      :disable="disabled"
      :to="{ name: 'quoteCar', params: { quoteId: $route.params.quoteId } }"
    />
    <QRouteTab
      class="q-py-sm"
      :ripple="false"
      label="Lease Details"
      :disable="!$store.getters['quote/quoteVariantValid'] || disabled"
      :to="{
        name: 'quoteLeaseDetails',
        params: { quoteId: $route.params.quoteId }
      }"
    />
    <QRouteTab
      class="q-py-sm"
      :ripple="false"
      label="Colour & Extras"
      :disable="!$store.getters['quote/quoteLeaseValid'] || disabled"
      :to="{
        name: 'quoteColourAndExtras',
        params: { quoteId: $route.params.quoteId }
      }"
    />
    <QRouteTab
      class="q-py-sm"
      :ripple="false"
      label="Order Details"
      :disable="!$store.getters['quote/quoteColourAndExtrasValid'] || disabled"
      :to="{
        name: 'quoteOrderDetails',
        params: { quoteId: $route.params.quoteId }
      }"
    />
    <QRouteTab
      class="q-py-sm"
      :ripple="false"
      label="Review Quote"
      :disable="!$store.getters['quote/quoteOrderDetailsValid'] || disabled"
      :to="{ name: 'quoteReview', params: { quoteId: $route.params.quoteId } }"
    />
  </QTabs>
</template>

<script>
import { QTabs, QRouteTab } from 'eclipx.ui';
import { mapState } from 'vuex';

/**
 * This component renders the tabs of the Quote pages.
 * The active tab is determined by matching the `:to` to the current route path.
 */
export default {
  name: 'QuoteTabs',
  props: {
    disabled: Boolean
  },
  computed: {
    ...mapState({ quote: (state) => state.quote.quote }),
    erpQuoteRef() {
      return this.quote.erpquote.erpQuoteRef;
    }
  },
  components: {
    QTabs,
    QRouteTab
  }
};
</script>
